import * as customerUtils from '@/utils/customer';
import isPwa from '@/helpers/isPwa';

export function buildOrderPayload({ state, rootState, getters, rootGetters }) {
    const preOrderDateTime = state.preOrderDateTime || null;
    const isAsap = preOrderDateTime === 'ASAP';
    const meta = buildMeta({ state });
    const customerLocale = getCustomerLocale({ rootState });

    return {
        customer: buildCustomer({ rootState, state, rootGetters }),
        preOrderDateTime: isAsap ? null : preOrderDateTime,
        deliveryAddress: rootState.deliveryAddress.deliveryAddress,
        items: state.items,
        fulfillmentMethod: state.fulfillmentMethod,
        paymentType: state.paymentType,
        isPreOrder: isAsap ? false : state.isPreOrder,
        deliveryFee: state.deliveryFee || rootState.venue.venue.deliveryFee,
        serviceCharge: rootState.venue.venue.serviceCharge,
        venueId: rootState.venue.venue.id,
        accountId: rootState.venue.venue.accountId,
        total: state.totalWithDiscount,
        tableId: state.selectedTableId || null,
        discountCodeId: calculateDiscountCodeId({ rootState, state, getters }),
        cartSubtotal: getters['cartSubtotal'],
        tip: getters['tip'],
        billId: rootState.bill.id,
        cutlery: state.cutlery,
        channel: isPwa() ? 'PWA' : 'WEB',
        giftCardPaymentAmount: rootState.giftCard.giftCardPayAmount,
        giftCardReference: rootState.giftCard.giftCardReference,
        noOfDiners: state.noOfDiners,
        poNumber: state.poNumber,
        attribution: rootGetters['marketing/marketingDetails'] || null,
        meta,
        customerLocale
    };
}

function buildCustomer({ state, rootState, rootGetters }) {
    const customer = rootState.customer;

    const { validFields } = customerUtils.filterUserInfo(
        rootGetters['venue/userInformationSettings'],
        customer
    );

    const payload = {
        notes: customer.notes,
        policyAgreed: rootGetters['customer/policyAgreed'](
            rootState.venue.venue.accountId
        ),
        piggy: {
            credits: 0,
            checkbox: customer.piggy.loyaltyCheckboxState,
            piggyProductDiscount: state.totalPiggyDiscount,
            rewardSelected: state.piggyRewardSelected
        },
        zonalDiscountSum: state.zonalDiscountSum,
        ...validFields
    };

    if (customer.como.discountSum > 0 || rootState.venue.venue.comoEnabled) {
        payload.como = {
            isAuth: rootGetters['customer/auth'],
            transactionId: customer.como.transactionId,
            openTime: customer.como.openTime,
            discountSum: customer.como.discountSum,
            deals: customer.como.deals,
            redeemAssets: customer.como.redeemAssets || [],
            identifierType: customer.identifierType
        };
    }

    return payload;
}

function buildMeta({ state }) {
    const meta = {};

    if (state.zonalBasketId) {
        meta.zonal = { basketId: state.zonalBasketId };
    }

    return meta;
}

function getCustomerLocale({ rootState }) {
    const customerLang = rootState.customer.lang;
    const venueLang = rootState.venue.venue.lang;

    if (!customerLang || customerLang === venueLang) {
        return null;
    }

    return customerLang;
}

function calculateDiscountCodeId({ rootState, state, getters }) {
    if (getters['isPiggyRewardActive']) {
        return null;
    }

    const manualDiscount = rootState.discount.details;

    if (manualDiscount) {
        return manualDiscount.id;
    }

    const autoDiscount = (rootState.venue.venue.autoAppliedDiscountCode ||
        [])[0];

    if (!autoDiscount) {
        return null;
    }

    const methods = autoDiscount.fulfillmentMethods || [];

    return methods.includes(state.fulfillmentMethod) ? autoDiscount.id : null;
}
